module.exports = __webpack_public_path__ + "static/media/bg.eec6a38a.png";